export default __webpack_public_path__ + "static/media/AccederOctubre13y14.1ec28a65.png";